"use client"

import { Button } from "@heroui/react"
import { useRouter } from "next/navigation"

export interface CenterAlignedCTAProps {
  description: string,
  btn_text: string,
  btn_link?: string,
  backgroundColor?: string,
  textColor?: string,
  title?:string,
}

const CenterAlignedCTA = ({ description, btn_text, backgroundColor = '#F9FAFB', textColor = '#ffff',title,btn_link="#"}: CenterAlignedCTAProps) => {

  const router = useRouter();

  return (
    <div className="space-y-8 py-8" style={{backgroundColor:backgroundColor}}>
      <div className="space-y-2 mx-auto">
        {(title && title?.length)?<h4 className="text-center font-medium text-xl/[30px] text-textf1">{title}</h4>:<></>}
        <p className="text-textf2 text-lg/[28px] text-center">{description}</p>
      </div>
      <div className="flex justify-center">
        <Button className="silverblue_btn mx-auto rounded-lg" onPress={()=>router.push(btn_link)}>{btn_text}</Button>
      </div>
    </div>
  )
}

export default CenterAlignedCTA
